module.exports = __webpack_public_path__ + "img/94037.776f3c5c.svg";